import { AfterViewChecked, Component, OnInit, Renderer2, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PricingService } from 'src/app/service/pricing.service';

@Component({
  selector: 'app-mini-pricer-widget',
  templateUrl: './mini-pricer-widget.component.html',
  styleUrls: ['./mini-pricer-widget.component.scss']
})
export class MiniPricerWidgetComponent implements OnInit {
  data: any;

  previousDateRef: any = null;
  currentDateRef: any = null;

  targetPrice = 0.0;
  widgetState = 'mini';
  refId = '58bf0bb84cedfd000136eee4';
  miniUrlRef = '';
  apr;
  rateSelection = 'First'
  disclaimerInfo;
  disclimerClick = false;
  cardLink = '';

  utmParams;
  innerWidth;
  elementWidth;

  isMobileResolution = false;

  constructor(private renderer: Renderer2, private pricingService: PricingService, private router: Router, private route: ActivatedRoute) {
    const currentDate = new Date();
    const dateMinus24Hours = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
    this.previousDateRef = dateMinus24Hours;
    this.isMobileResolution = window.innerWidth <= 400
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Update isMobileResolution based on window width
    this.isMobileResolution = window.innerWidth <= 400;
  }

  onTriggerSearch(miniPricerRef, value, data) {
    const loanCriterias = miniPricerRef.miniPricerPref.search.loanCriterias
      .map(criteria => criteria && criteria.name)
      .filter(name => name !== null);

    let adjustedRateDiff: any = {};
    const flatRates = data.reduce((acc, rateData, index) => {
      const name = loanCriterias[index];
      let indexTopick: number;
      if (name && rateData) {
        if (this.rateSelection === 'First') {
          indexTopick = 0
        } else {
          indexTopick = rateData.length - 1
        }
        if (value !== null) {
          adjustedRateDiff = {
            adjustedRates: rateData[indexTopick].adjustedRates,
            name: name
          };

          // Add Apr if apr is true
          if (this.apr === 'true') {
            adjustedRateDiff['apr'] = rateData[indexTopick].apr;
          }

        } else {
          adjustedRateDiff = {
            adjustedRates: rateData[indexTopick].adjustedRates,
            name: name
          };
          // Add Apr if apr is true
          if (this.apr === 'true') {
            adjustedRateDiff['apr'] = rateData[indexTopick].apr;
          }
        }
        acc.push(adjustedRateDiff);
      }

      return acc;
    }, []);

    if (value !== null) {
      this.data = {
        ...this.data, ...{
          previous: flatRates
        }
      };
    } else {
      this.data = {
        ...this.data, ... {
          current: flatRates
        }
      };
    }

    if (this.data.current) {
      this.elementWidth = this.data.current.length * 200 + 'px';
    }

  }

  setDateAndTargetPriceProperty(value, price, data) {
    this.pricingService
      .getSearch(this.refId)
      .toPromise()
      .then((ref) => {
        ref.miniPricerPref.search.targetPrice = price;
        ref.miniPricerPref.search.date = value;
        this.onTriggerSearch(ref, value, data);
      });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const {
        widgetState: widgetStateParams,
        refId: paramRefId,
        primaryColour,
        secondaryColor,
        miniUrl,
        targetPrice,
        apr,
        rateSelection,
        disclaimerInfo,
        utmParams,
        cardLink
      } = params;

      this.widgetState = widgetStateParams;
      this.miniUrlRef = miniUrl;
      this.refId = paramRefId;
      this.targetPrice = targetPrice === null || targetPrice === undefined ? null : parseFloat(targetPrice);
      this.apr = apr;
      this.rateSelection = rateSelection;
      this.disclaimerInfo = disclaimerInfo;
      this.utmParams = decodeURIComponent(utmParams);
      this.cardLink = cardLink;
    });

    const currentTimestamp = new Date().getTime();

    this.pricingService.getPreviousPricingResponse(currentTimestamp).toPromise().then((data) => {
     this.setDateAndTargetPriceProperty(this.previousDateRef, this.targetPrice, data);
    });

    this.pricingService.getCurrentPricingResponse(currentTimestamp).toPromise().then((data) => {
      this.setDateAndTargetPriceProperty(this.currentDateRef, this.targetPrice, data);
     });

    this.innerWidth = window.innerWidth;
  }

  elementClick() {
    if (this.miniUrlRef) {
      window.open(this.miniUrlRef);
    } else {
      this.widgetState = ['expanded', 'expanded-grid'].includes(this.widgetState) ? 'mini' : this.widgetState = 'expanded';
    }
  }

  ratesDisclimerClick() {
    this.disclimerClick = true;
  }

  closeDisclimerClick() {
    this.disclimerClick = false;
  }
}
